import { Box, Button, HStack, Input, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import axiosInstance from "../../config/axiosInstance";
import OrdersTable from "../Customer-dashboard/ReceptionistOrders/OrdersTable";

const TrackAdmin = () => {
  const [searchBy, setSearchBy] = useState("billNumber");
  const [searchText, setSearchText] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

const handleSearch = async () => {
  if (!searchText.trim()) return;
  setLoading(true);

  try {
    const params = {};

    // Decide what to send to backend
    if (searchBy === "billNumber") {
      params.bill = searchText; // strict bill number search
    } else if (searchBy === "phone") {
      params.phone = searchText; // partial phone search
    } else {
      params.search = searchText; // general search
    }

    const res = await axiosInstance.get("/api/orders", { params });
    const fetched = res.data.orders || [];
    setOrders(fetched);
    setMessage(fetched.length === 0 ? "No order found for this search." : "");
  } catch (err) {
    setOrders([]);
    setMessage(
      "Search failed: " + (err?.response?.data?.message || err.message)
    );
  } finally {
    setLoading(false);
  }
};



  return (
    <Box p={{ base: 4, md: 6 }} bg="gray.50" minH="100vh">
      <Box bg="white" p={6} borderRadius="md" mb={8} boxShadow="sm">
        <Text color="red.500" fontWeight="bold" mb={2}>
          Track your order
        </Text>
        <HStack spacing={2} mb={4}>
          <Text
            onClick={() => setSearchBy("billNumber")}
            cursor="pointer"
            fontWeight={searchBy === "billNumber" ? "bold" : "normal"}
          >
            Bill number
          </Text>
          <Text color="gray.500">/</Text>
          <Text
            onClick={() => setSearchBy("phone")}
            cursor="pointer"
            fontWeight={searchBy === "phone" ? "bold" : "normal"}
          >
            Phone number
          </Text>
        </HStack>
        <Stack direction={{ base: "column", sm: "row" }} spacing={4}>
          <Input
            placeholder={
              searchBy === "billNumber"
                ? "Enter bill number"
                : "Enter phone number"
            }
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            type={searchBy === "phone" ? "tel" : "text"}
          />
          <Button colorScheme="red" onClick={handleSearch} isLoading={loading}>
            Search
          </Button>
        </Stack>
        {message && (
          <Box
            bg="white"
            p={6}
            rounded="md"
            boxShadow="sm"
            textAlign="center"
            mt={4}
          >
            <Text color="red.500" fontWeight="bold">
              {message}
            </Text>
          </Box>
        )}
      </Box>
      {orders.length > 0 && (
        <Box bg="white" p={6} borderRadius="md" boxShadow="sm" overflowX="auto">
          <Text mb={4}>
            Showing results for <b>{searchText}</b>
          </Text>
          <OrdersTable
            data={orders}
            fetchOrders={handleSearch}
            orderLoading={loading}
          />
        </Box>
      )}
    </Box>
  );
};

export default TrackAdmin;
